import { memo } from "react";
import { Badge } from "../../../../components/Badge/Badge.tsx";
import { BaseClickableIcon } from "../../../../components/Icon/BaseClickableIcon.tsx";
import { ActionContentTile } from "../../../components/ActionContentTile.tsx";
import type { Asset } from "../../types.ts";

export const MemoDeletedAssetTile = memo(
  ({
    asset,
    isUndeleteLoading,
    undeleteAsset,
  }: {
    asset: Asset;
    isUndeleteLoading: boolean;
    undeleteAsset: ({ uuids }: { uuids: string[] }) => void;
  }) => (
    <ActionContentTile
      content={asset.content}
      id={`DeletedAssetImageTile-${asset.uuid}`}
      topRightElement={
        <div className="flex-row z-10 gap-100">
          <Badge size="sm" color="neutral" label="Archived" />
        </div>
      }
      bottomRightElement={
        <div className="invisible group-hover:visible">
          <div className="flex-row gap-200">
            <BaseClickableIcon
              name="ArchiveRestore"
              className="z-10 tile-action"
              tooltip={{ side: "top", content: "Unarchive" }}
              disabled={isUndeleteLoading}
              onClick={() => {
                undeleteAsset({
                  uuids: [asset.uuid],
                });
              }}
            />
          </div>
        </div>
      }
    />
  ),
  (prevProps, nextProps) =>
    prevProps.asset.uuid === nextProps.asset.uuid &&
    prevProps.asset.content.url === nextProps.asset.content.url &&
    prevProps.isUndeleteLoading === nextProps.isUndeleteLoading,
);

MemoDeletedAssetTile.displayName = "MemoDeletedAssetTile";
